import React from 'react';
import { PRESETS } from '../../lib/charts/rangePresets';

/** Segmented 8h / 24h / 3d / Custom control. Compact (34 px, 13 px text) on phones, 32 px on desktop. */
const TimeRangeToggle = ({ value, onChange, labels, customLabel }) => {
    const items = [...PRESETS.map((p) => ({ key: p, label: labels[p] })), { key: 'custom', label: customLabel || labels.custom }];
    return (
        <div role="radiogroup" className="inline-flex rounded-lg border border-slate-300 dark:border-slate-600 overflow-hidden text-[13px] md:text-sm">
            {items.map((it) => {
                const active = it.key === value;
                return (
                    <button key={it.key} type="button" role="radio" aria-checked={active} onClick={() => onChange(it.key)}
                            className={`min-h-[34px] md:min-h-[32px] px-2.5 md:px-3 whitespace-nowrap transition-colors border-r last:border-r-0 border-slate-300 dark:border-slate-600 ${
                                active ? 'bg-blue-600 text-white font-semibold' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700'
                            }`}>
                        {it.label}
                    </button>
                );
            })}
        </div>
    );
};

export default TimeRangeToggle;
